import { StubPage } from '../components/StubPage';

export function HsLookupPage(): JSX.Element {
  return <StubPage navKey="hsLookup" />;
}
